import { get, post, put } from './Tools';

const listTemplates = async (tipo = null, idioma = null) => {
  let url = `${process.env.REACT_APP_SERVER}template_email`;
  const params = [];
  if (tipo) params.push(`tipo=${tipo}`);
  if (idioma) params.push(`idioma=${idioma}`);
  if (params.length > 0) url += `?${params.join('&')}`;
  
  const response = await get(url);
  return response;
};

const getTemplate = async (template_id) => {
  const response = await get(`${process.env.REACT_APP_SERVER}template_email/${template_id}`);
  return response;
};

const createTemplate = async (payload) => {
  const response = await post(`${process.env.REACT_APP_SERVER}template_email`, payload);
  return response;
};

const updateTemplate = async (template_id, payload) => {
  const response = await put(`${process.env.REACT_APP_SERVER}template_email/${template_id}`, payload);
  return response;
};

const setDefaultTemplate = async (template_id) => {
  const response = await post(`${process.env.REACT_APP_SERVER}template_email/${template_id}/set-default`, {});
  return response;
};

const deactivateTemplate = async (template_id) => {
  const response = await post(`${process.env.REACT_APP_SERVER}template_email/${template_id}/deactivate`, {});
  return response;
};

export { 
  listTemplates, 
  getTemplate, 
  createTemplate, 
  updateTemplate, 
  setDefaultTemplate, 
  deactivateTemplate 
};
